<template>
  <ul data-animate="list" class="page-projects-list__list">
    <li
      v-for="(item, index) in projects"
      :key="item.id"
      :class="{ 'm-top-4': index > 0 }"
    >
      <div class="page-projects-list__list__item">
        <PagesProjectsListBlock :project="item" />
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PagesProjectsList',
}
</script>

<script setup>
const props = defineProps({
  projects: Array,
})
</script>
